import { render, staticRenderFns } from "./CategorySection.vue?vue&type=template&id=084b62f2&"
import script from "./CategorySection.vue?vue&type=script&lang=js&"
export * from "./CategorySection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kristiankalva/Local Sites/ensign-boligprosjekter/app/public/wp-content/plugins/ensign-boligprosjekter/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('084b62f2')) {
      api.createRecord('084b62f2', component.options)
    } else {
      api.reload('084b62f2', component.options)
    }
    module.hot.accept("./CategorySection.vue?vue&type=template&id=084b62f2&", function () {
      api.rerender('084b62f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CategorySection.vue"
export default component.exports